import { Injectable } from '@angular/core';
import { SearchCriteria } from '../search/search/_model/search-criteria';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../_common/constants';
import { map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { PsiData } from '../_models/psi-data';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http:HttpClient, private commonService: CommonService) { }

  set header(data){
    this.commonService.header = data;
  }

  get runningServices(){
    return this.commonService.runningServices;
  }
  
  search(searchCriteria: SearchCriteria):Observable<any> {
    return this.http.post<any>(API_URL.Search, searchCriteria, {observe: 'response'})
        .pipe(map(searchData => {
            return searchData.body.result;
        }));
  }

  public getSearchStorage(){
    let psiData: PsiData = this.commonService.getData();

    return psiData.search;
  }

  public createSearchStorage(data){
    let psiData:PsiData = JSON.parse(sessionStorage.getItem('psiData'));
    psiData.search = data;
    this.commonService.storeData(psiData);
  }

  public removeSearchStorage(){
    let psiData: PsiData = JSON.parse(sessionStorage.getItem('psiData'));
    if(psiData.search){
      psiData.search = null;
    }
    this.commonService.storeData(psiData);
  }

  storeAccountData(account){
    let psiData:PsiData = JSON.parse(sessionStorage.getItem('psiData'));
    psiData.selectedAccount = account;
    this.commonService.storeData(psiData);
  }
  
  fetchAccountByPolicy(policyNumber){
    return this.commonService.fetchAccountByPolicy(policyNumber);
  }
}
